import { render, staticRenderFns } from "./aStaffCommunityList.vue?vue&type=template&id=7dae48f6&scoped=true"
import script from "./aStaffCommunityList.vue?vue&type=script&lang=js"
export * from "./aStaffCommunityList.vue?vue&type=script&lang=js"
import style0 from "./aStaffCommunityList.vue?vue&type=style&index=0&id=7dae48f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dae48f6",
  null
  
)

export default component.exports